import React from 'react'

import Container from '@material-ui/core/Container'
import T from 'components/FormattedMessage'
import ActionContext from 'components/ActionContext'
import CenteredBottom from 'components/CenteredBottom'
import NavigationHeader from 'components/NavigationHeader'

import { MessageKey } from 'types'

import HelpLayer from './components/HelpLayer/HelpLayer'

type Tab = {
  title: React.ReactNode
  component?: React.ComponentType<{}>
}

interface Props<TProps> {
  title: React.ReactNode
  isLoading?: boolean
  errorCode?: string
  component?: React.ComponentType<TProps>
  componentProps?: TProps
  tabs?: Array<Tab>
  selectedTab?: number
  bottomChild?: React.ReactNode
  help?: {
    iconUrl: string
    title: MessageKey
    message: MessageKey
    buttonLabel: MessageKey
  }
  onTabSelect?: (tabIndex: number) => void
  onBack?: () => void
}

type State = {
  isHelpOpen: boolean
}

class GameCreationScreen<TProps> extends React.Component<Props<TProps>, State> {
  constructor(props: Props<TProps>) {
    super(props)
    this.state = {
      isHelpOpen: false,
    }
  }

  showHelp = () => {
    this.setState({ isHelpOpen: true })
  }

  hideHelp = () => {
    this.setState({ isHelpOpen: false })
  }

  renderContent = () => {
    const { tabs, selectedTab, component, componentProps, bottomChild, help } = this.props

    const tab = tabs && selectedTab !== undefined && tabs[selectedTab]
    const Component = (tab && tab.component) || component

    return (
      <>
        {Component ? <Component {...componentProps!} /> : null}
        {bottomChild && <CenteredBottom fillHeight={50}>{bottomChild}</CenteredBottom>}
        {help && (
          <HelpLayer
            open={this.state.isHelpOpen}
            onClose={this.hideHelp}
            iconUrl={help.iconUrl}
            title={<T id={help.title} />}
            message={<T id={help.message} />}
            buttonLabel={<T id={help.buttonLabel} />}
          />
        )}
      </>
    )
  }

  render() {
    const { isLoading, errorCode, title, onBack, tabs, help, selectedTab, onTabSelect } = this.props

    return (
      <>
        <NavigationHeader
          tabs={tabs}
          title={title}
          onBackClick={onBack}
          selectedTab={selectedTab}
          onTabSelect={onTabSelect}
          onInfoClick={help && this.showHelp}
        />
        <Container
          maxWidth="md"
          disableGutters
        >
          <ActionContext
            isLoading={Boolean(isLoading)}
            errorCode={errorCode}
            component={this.renderContent}
            componentProps={{}}
          />
        </Container>
      </>
    )
  }
}

export default GameCreationScreen
